import { createSlice } from "@reduxjs/toolkit";

const categoriesSlice = createSlice({
    name: "categories",
    initialState: {
        categoriesDetails: {},
        categoriesError: null,
        categoriesLoading: false,
    },
    reducers: {
        setCategoriesDetails: (state, { payload }) => {
            state.categoriesDetails = payload;
        },
        setCategoriesError: (state, { payload }) => {
            state.categoriesError = payload;
        },
        setCategoriesLoading: (state, { payload }) => {
            state.categoriesLoading = payload;
        },
    }
});

export const { setCategoriesDetails, setCategoriesError, setCategoriesLoading } = categoriesSlice.actions;

export default categoriesSlice.reducer;